import React, { useState, useEffect } from 'react'
import { getUserTemplate, uploadUserExcel } from '@vt/apis/lib-ex/v2/users'
import tw from 'twin.macro'
import styled from '@emotion/styled'
import { Button, FileUpload } from '@ow/comps'

const StyledContent = styled.div`
  .uppy-DragDrop-inner {
    padding: 0;
  }
`
const Steps = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 0.75rem;
  ${tw`ml-5`}
  .num {
    border: solid 1px #999;
    ${tw`float-left rounded-full w-5 h-5 text-center mr-2 flex items-center justify-center`}
  }
  .dot {
    width: 4px;
    height: 4px;
    border-radius: 3px;
    ${tw`float-left mr-5`}
  }
`
const Line = styled.div`
  width: 1px;
  height: 32px;
  margin-left: 1.35rem;
`

const UploadUser = function ({ appId, uppyId, gotoBack, uploadDone }) {
  const [fileInfo, setFileInfo] = useState(null)
  const [templateLink, setTemplateLink] = useState('')

  const dealExcelData = (excelData) => {
    return excelData.map((data, index) => {
      if (uppyId === 'invite') {
        return {
          index,
          name: data[0],
          mobile: data[1],
        }
      }
      return {
        index,
        name: data[0],
        username: data[1],
        password: data[2],
        repeatpwd: data[3],
        mobile: data[4],
      }
    })
  }
  const upload = () => {
    const formData = new FormData()
    const { data } = fileInfo
    formData.append('file', data)
    uploadUserExcel(appId, formData).then((res) => {
      uploadDone(dealExcelData(res))
    })
  }

  useEffect(() => {
    const params = {}
    if (uppyId === 'invite') {
      params.type = 1
    }
    getUserTemplate(appId, params).then((data) => {
      setTemplateLink(data)
    })
  }, [])

  return (
    <StyledContent className="w-full h-full flex flex-col relative">
      <div
        className="w-full mt-3 pt-3 pb-6 px-4 mb-6 rounded-box"
        style={{
          background: 'var(--ow-bg-comps-color)',
          fontSize: '0.75rem',
        }}
      >
        <b>导入提示</b>
        <div className="mt-2 font-extralight">
          <p>
            <b className="mr-1 font-bold">1.</b>
            请先下载导入模板，按照导入模板的提示，规范填写后进行导入
          </p>
          <p className="mt-1">
            <b className="mr-1">2.</b>
            支持多次导入，以最后一次导入的数据为准，请谨慎操作
          </p>
        </div>
      </div>
      <Steps>
        <div className="dot bg-primary" />
        <div className="text-gray-1 float-left mr-2">
          01.下载用户通讯录模版，批量填写用户信息
        </div>
        <a className="cursor-pointer text-primary-700" href={templateLink}>
          下载用户模板
        </a>
      </Steps>
      <Line className="bg-primary" />
      <Steps className="mb-6">
        <div className="dot bg-primary" />
        <div className="text-gray-1">02.上传填写好的用户信息表</div>
      </Steps>
      <FileUpload
        uppyId={uppyId}
        fileInfo={fileInfo}
        updateFileInfo={(data) => {
          setFileInfo(data)
        }}
      />
      <div className="w-full flex flex-row items-center mt-10 pl-8">
        <Button onClick={gotoBack} className="mr-2" stroke>
          取消
        </Button>
        <Button disabled={!fileInfo} onClick={upload} type="primary">
          上传
        </Button>
      </div>
    </StyledContent>
  )
}

export default UploadUser
